// 获取banner
export const GET_BANNERS = 'GET_BANNERS';

// 获取所有公告
export const GET_BULLETINS = 'GET_BULLETINS';

// 获取中奖名单
export const GET_WINNERS = 'GET_WINNERS';

// 获取验证码
export const GET_VALIDCODE = 'GET_VALIDCODE';

// 获取公告详情
export const GET_BULLETIN_DETAIL = 'GET_BULLETIN_DETAIL';

// 关闭中间用户滚动列表
export const CLOSE_WINNER_NOTICE = 'CLOSE_WINNER_NOTICE'

// 打开关闭验证码输入框
export const TOGGLE_VAILDCODE = 'TOGGLE_VAILDCODE';

// 域名验证
export const GET_CHECK_URLS = 'GET_CHECK_URLS';

// 标示域名验证是否验证成功
export const MARK_DOMAIN_STATUS = 'MARK_DOMAIN_STATUS';

// 登录页清楚域名验证数据
export const CLEAR_DOMAIN_STATUS = 'CLEAR_DOMAIN_STATUS';

// 域名测速
export const GET_SPEED_DOMAINS = 'GET_SPEED_DOMAINS';

// 获取环境变量，常量等
export const GET_WEB_SETTINGS = 'GET_WEB_SETTINGS';

// 获取站内信列表
export const GET_MESSAGES = 'GET_MESSAGES'

// 获取站内信详情
export const GET_MESSAGES_DETAIL = 'GET_MESSAGES_DETAIL'

// 删除站内信
export const DELETE_MESSAGES = 'DELETE_MESSAGES'

// 多选删除站内信
export const DELETE_MULTI_MESSAGE = 'DELETE_MULTI_MESSAGE'

// 删除所有站内信
export const DELETE_ALL_MESSAGE = 'DELETE_ALL_MESSAGE'

// 获取收藏
export const FAVORITES_LIST = 'FAVORITES_LIST';

// 批量添加收藏
export const FAVORITES_CREATE = 'FAVORITES_CREATE';

// 批量删除收藏
export const FAVORITES_DELETE = 'FAVORITES_DELETE';